export default __webpack_public_path__ + "static/media/black-logo.07262ecc.png";